import React from 'react';
import { LockIcon, CheckIcon, PlayIcon, CircleIcon } from 'lucide-react';
export function App() {
  const tours = [{
    name: 'VESSEL REPORTS TOUR',
    locked: false,
    completed: true
  }, {
    name: 'SAFETY DRILL MATRIX TOUR',
    locked: false,
    completed: false
  }, {
    name: 'RECORD OF CREW TRAINING TOUR',
    locked: false,
    completed: false
  }, {
    name: 'SAFETY INSPECTIONS TOUR',
    locked: true,
    completed: false
  }];
  return <div className="w-full min-h-screen bg-white flex" data-id="element-0">
      {/* Left Content Section */}
      <div className="flex-1 p-8 max-w-2xl" data-id="element-1">
        <div className="text-[15px] text-[#323232] mb-2" data-id="element-2">
          Welcome to the Ephemeris Orientation Tool
        </div>
        <h2 className="mt-0 mb-4 font-medium leading-tight text-[30px] text-[#323232]" data-id="element-3">
          Safety Management Applications Tours
        </h2>
        <div className="mb-6" data-id="element-4">
          <p className="mb-3 mt-0 text-sm text-[#323232] leading-relaxed" data-id="element-5">
            The <strong className="font-bold" data-id="element-6">DPA's role</strong> is to ensure
            the vessel upholds the highest standards of{' '}
            <strong className="font-bold" data-id="element-7">safety and security</strong> by
            actively monitoring the{' '}
            <strong className="font-bold" data-id="element-8">
              Safety Management System (SMS)
            </strong>
            , enforcing <strong className="font-bold" data-id="element-9">ISPS Code</strong>{' '}
            security measures, and ensuring compliance with all{' '}
            <strong className="font-bold" data-id="element-10">applicable regulations</strong> for
            both the crew and vessel.
          </p>
          <button className="text-[#43b2e3] text-sm cursor-pointer bg-transparent border-0 p-0" data-id="element-11">
            Read More
          </button>
        </div>
        <div className="mb-6" data-id="element-12">
          <button type="button" className="cursor-pointer font-sans text-sm font-medium uppercase bg-[#2f6bbb] inline-flex justify-center items-center gap-2 px-8 py-3 text-white border-0 rounded-lg hover:bg-[#2557a3] hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]" data-id="element-13">
            <PlayIcon className="w-5 h-5" data-id="element-14" />
            START FROM BEGINNING
          </button>
        </div>
        <div className="mb-4 text-sm text-[#323232]" data-id="element-15">
          or navigate to any section by selecting its title below:
        </div>
        {/* Warning Box */}
        <div className="mb-6 p-4 bg-amber-50 border-l-4 border-amber-500 rounded" data-id="element-16">
          <p className="text-sm text-[#323232] m-0" data-id="element-17">
            Tours shown as unavailable are as a result of your Ephemeris access
            permission.{' '}
            <strong className="font-semibold" data-id="element-18">
              For access to applications to complete the tours, contact your HOD
              or Captain.
            </strong>
          </p>
        </div>
        {/* Progress Bar */}
        <div className="mb-6" data-id="element-19">
          <div className="flex items-center gap-3 mb-2" data-id="element-20">
            <span className="text-2xl font-semibold text-[#2f6bbb]" data-id="element-21">72%</span>
            <span className="text-sm text-gray-600" data-id="element-22">Complete</span>
          </div>
          <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-23">
            <div className="h-full w-[72%] bg-[#2f6bbb] rounded-full" data-id="element-24"></div>
          </div>
        </div>
        {/* Tours List */}
        <div className="space-y-3" data-id="element-25">
          {tours.map((tour, index) => <div key={index} className={`flex items-center gap-3 p-4 rounded-lg border transition-all duration-300 ${tour.locked ? 'bg-gray-50 border-gray-200 opacity-60' : tour.completed ? 'bg-white border-gray-300' : 'bg-white border-gray-300 cursor-pointer hover:border-[#2f6bbb] hover:shadow-lg hover:scale-[1.02] hover:-translate-y-1'}`} data-id="element-26">
              {tour.completed ? <CheckIcon className="w-5 h-5 text-[#2f6bbb] flex-shrink-0" data-id="element-27" /> : tour.locked ? <LockIcon className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-28" /> : <CircleIcon className="w-5 h-5 text-[#2f6bbb] flex-shrink-0 stroke-[1.5px] fill-transparent transition-transform duration-300 group-hover:scale-110" data-id="element-29" />}
              <span className={`text-sm font-medium uppercase tracking-wide ${tour.completed ? 'line-through text-gray-500' : tour.locked ? 'text-gray-400' : 'text-[#323232]'}`} data-id="element-30">
                {tour.name}
              </span>
              {tour.locked && <span className="ml-auto text-xs text-gray-400 italic" data-id="element-31">
                  Contact HOD
                </span>}
              {!tour.locked && !tour.completed && <button className="ml-auto text-xs text-[#2f6bbb] font-medium hover:underline transition-all duration-200" data-id="element-32">
                  Start Tour
                </button>}
            </div>)}
        </div>
      </div>
      {/* Right Image Section */}
      <div className="w-[45%] flex items-center justify-center" data-id="element-33">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sX7JwKWkNV7dSvNDG2ePH8/Virtual-dpa-banner-welcome_1.jpg" alt="Virtual DPA" className="w-full h-full object-cover" data-id="element-34" />
      </div>
    </div>;
}